import { Icon } from "icons";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "ui";

import { ConfigurableFilterGroup } from "src/components/ConfigurableFilterGroup";
import {
  type FilterAction,
  type FilterGroupConfig,
  getActiveFilterCount,
  type SelectedFilters,
} from "src/components/filterConfig";

interface ConfigurableFiltersProps {
  label: string;
  clearLabel: string;
  config: FilterGroupConfig[];
  selectedFilters: SelectedFilters;
  saveAction?: {
    label: string;
    onSelect: () => void;
  };
  onAction: (action: FilterAction) => void;
}

export function ConfigurableFilters(props: ConfigurableFiltersProps) {
  const activeFilterCount = getActiveFilterCount(
    props.config,
    props.selectedFilters,
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Icon name="tabler-filter" />
          {props.label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-52">
        {props.config.map((group) => {
          return (
            <ConfigurableFilterGroup
              key={group.filter}
              group={group}
              selectedFilters={props.selectedFilters}
              onAction={props.onAction}
            />
          );
        })}

        {activeFilterCount > 0 ? (
          <>
            <DropdownMenuSeparator />
            {props.saveAction ? (
              <DropdownMenuItem onSelect={props.saveAction.onSelect}>
                <Icon name="tabler-plus" />
                {props.saveAction.label}
              </DropdownMenuItem>
            ) : null}
            <DropdownMenuItem
              onSelect={() => {
                props.onAction({ type: "filters-cleared" });
              }}
            >
              {props.clearLabel}
            </DropdownMenuItem>
          </>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
